import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_POS_REQUEST: '',
  GET_POS_SUCCESS: '',
  GET_POS_FAILURE: '',

};

types = setStoreTypeValues(types, 'authPOS');

export default types;
